import React from "react";
import KakaoIcon from "../assets/images/payment/kakao_LOGO-07.png";

interface CustomerCenterButtonProps {
  className?: string;
}

const KAKAO_CHANNEL_URL = "https://pf.kakao.com/_WQzFn";

const CustomerCenterButton = ({
  className = "",
}: CustomerCenterButtonProps) => {
  return (
    <a
      href={KAKAO_CHANNEL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-2 bg-white rounded-xl px-2 font-bold text-base shadow border border-[#E5E500] hover:brightness-95 active:scale-95 ${className}`}
    >
      <img src={KakaoIcon} alt="kakao" className="w-14 h-14" />
      고객센터
    </a>
  );
};

export default CustomerCenterButton;
